import { COLORS } from "../../../../../styles/variables"

export const DrawerStyle = {
    maxHeight: "70%",
    height: "auto",
    width: "100%",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    display: 'flex', 
    alignItems: 'center',
    margin: "0 auto",
}

export const BoxMain = {
    padding: "8px 12px 16px 12px", 
    minHeight: "200px", 
    maxWidth: "736px", 
    width: "100%",
}

export const BoxImg = {
    height: '60px',
    width: '60px',
    objectFit: 'cover',
    borderRadius: '50%',
}

export const TypAuthor = {
    lineHeight: "18px",
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflowWrap: 'anywhere',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 1,
}

export const BtnTags = {
    fontSize: '16px', 
    fontWeight: 400, 
    color: COLORS.BLACK,

    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 1,
}
